// Typed patient responsibility on a hand-keyed remit (plan Step 13, S13-w). An EOB states
// patient responsibility by reason — X12 CARC 1 Deductible, 2 Coinsurance, 3 Co-payment,
// or another PR reason — and the server keeps `patient_responsibility` as their sum.
// Leaving all four blank posts an untyped lump, exactly as before.

export const TYPED_PR = [
  { field: 'pr_deductible',  label: 'Deductible (PR-1)' },
  { field: 'pr_coinsurance', label: 'Coinsurance (PR-2)' },
  { field: 'pr_copay',       label: 'Copay (PR-3)' },
  { field: 'pr_other',       label: 'Other PR' },
];

const cents = (v) => Math.round((parseFloat(v) || 0) * 100);

/** Form strings for a saved remit's split — blank when the remit is untyped. */
export function typedPrFormValues(remit) {
  const typed = TYPED_PR.some(({ field }) => cents(remit?.[field]) !== 0);
  return Object.fromEntries(TYPED_PR.map(({ field }) => [field, typed ? String(remit[field] ?? '') : '']));
}

/** Whether any typed field is filled, and their sum in dollars. */
export function typedPrTotal(values) {
  const typed = TYPED_PR.some(({ field }) => values[field] !== '' && values[field] != null);
  const total = TYPED_PR.reduce((s, { field }) => s + cents(values[field]), 0) / 100;
  return { typed, total };
}

/** The payload fields: the four parts when typed (the server derives the total), else {}. */
export function typedPrPayload(values) {
  if (!typedPrTotal(values).typed) return {};
  return Object.fromEntries(TYPED_PR.map(({ field }) => [field, parseFloat(values[field]) || 0]));
}
